<template>
  <span class="edit-button">
    <el-button size="mini" type="warning" @click="showDialog()">Edit</el-button>

    <el-dialog
      title="Edit IP Server"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : ''"
      top="5vh"
    >
      <el-form
        :model="formData"
        ref="editIpForm"
        label-width="150px"
        size="small"
        :rules="formDataRule"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-form-item label="IP" prop="ip">
          <el-input v-model="formData.ip"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input v-model="formData.description" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submiting" @click="submit()"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { getIP, updateIP } from "@/api/ip-server";
export default {
  props: {
    uid: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      dialogVisible: false,
      submiting: false,
      formData: {
        ip: "",
        description: "",
      },
      formDataRule: {
        ip: [
          {
            required: true,
            message: "Please enter IP Address",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    showDialog() {
      const loading = this.$notifyloading("Loading data...");
      getIP(this.uid).then(({ result, data }) => {
        loading.close();
        if (result) {
          this.formData.ip = data.ip;
          this.formData.description = data.description;
          this.dialogVisible = true;
        }
      });
    },

    submit() {
      this.submiting = true;
      updateIP(this.uid, this.formData).then(({ result }) => {
        this.submiting = false;
        if (result) {
          
          this.dialogVisible = false;
          this.$emit("on-submited", true);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.edit-button {
  margin-right: 5px;
}
</style>